import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import lozad from 'lozad';

import LoadingIcon from '../../components/LoadingIcon';
import EmailSignup from '../../components/Sections/EmailSignup';
import BandcampPlayerLarge from '../../components/Media/BandcampPlayerLarge';
import SpotifyPlayerLarge from '../../components/Media/SpotifyPlayerLarge';
import SpotifyPlayerSmall from '../../components/Media/SpotifyPlayerSmall';
import SpotifyFollowButton from '../../components/Media/SpotifyFollowButton';
import YoutubeVideo from '../../components/Media/YoutubeVideo';
import SongKickTourBox from '../../components/Media/SongKickTourBox';
import About from '../../components/Sections/About';
import SocialLinks from '../../components/Sections/SocialLinks';
import FeaturedShows from '../../components/Sections/FeaturedShows';
import PromotionalHero from '../../components/PromotionalHero';

function mapStateToProps(state) {
   return {}
}

function mapDispatchToProps(dispatch) {
  return {}
}

class Home extends Component {

  handleClickBuyAlbum() {
    ReactGA.event({
        category: 'Click',
        action: 'Buy Album',
    });
  }

  handleClickShopNow() {
    ReactGA.event({
        category: 'Click',
        action: 'Shop Now',
    });
  }

  render() {


    // let album_bound_and_revolving = 'https://open.spotify.com/embed/album/7KFf0FEtLaqyLDWBIbuPip';
    // let album_luggage_underneath = 'https://open.spotify.com/embed/album/1KjUyIXBTwWHJ5gFeEMRLS';
    // let album_spare_parts = 'https://open.spotify.com/embed/album/432fXgHmXnZTLLNr406xUR';
    // let video_link = "https://www.youtube.com/embed/V8VjhGliTFs";
    // let video_link = 'https://www.youtube.com/embed/G8IfbiqnS1w'; // Gilded Guilt High Dive
    // let video_link = 'https://www.youtube.com/embed/ivr20774r9I'; // hot wax release video
    // let video_link = 'https://www.youtube.com/embed/Wblrwviq1N4' // nine o clock shadow
    // let video_link = 'https://www.youtube.com/embed/lHDzNfpuphY';
    // let video_link = 'https://www.youtube.com/embed/L5eC78mSFwI' // Hot Wax official video
    // let video_link = 'https://www.youtube.com/embed/UpPd2Q5D11o' // Nectar Lounge Video
    let video_link = 'https://www.youtube.com/embed/D2pGMyVsiec' // Tractor Tavern Video


    return (
      <div className="Home">

        <div className="Home__section">
          <YoutubeVideo src={video_link} />
        </div>
        


          <div className="Home__section Home__about">
            <h1>
            <span className="highlight">Moose Almighty is an indie rock jam band from Seattle, WA.</span> Their modern approach to a retro sound blends seventies hard rock with swampy funk, blues, synth freakouts and dynamic improvisation, reminiscent of a hazy, acid tinged Saturday night in a southern dive bar. 
            </h1>
          </div>

          <div className="Home__section Home__spare-parts">
            <img src="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/Spare_Parts_Moose_Almighty_Album_Cover--800.jpg" />
            <p>
              Moose Almighty’s third studio album 'Spare Parts’ was named the independent album of the year by Mic1Park Music Media who said <span class="highlight--2">“All self-produced, self-engineered - and all things between - this album is 10 out of 10 across the board. If you’re not careful, you can easily have this playing in the background and not even remember if you put on Moose Almighty or Grateful Dead.”</span> 
            </p>
            <p>
              Robert Fadley of JamBandPurist praised ‘Spare Parts’ as <span class="highlight--2">“A brand new ripping album... Ambitious and highly eclectic, these new tracks show the growth and knowledge that Moose Almighty has acquired from their last studio endeavor, while also incorporating what they have learned playing live shows. Moose Almighty has stepped up into another level...”</span> 
            </p>

            <a target="_blank" href="https://open.spotify.com/album/432fXgHmXnZTLLNr406xUR?si=Wv1sNxeBQBCrVoeT9jIIgw&dl_branch=1">
              <button className="btn btn--outline">
                Listen on Spotify
              </button>
            </a>

          </div>

          <div className="Home__section card Home__tour__card">
            <SongKickTourBox />
          </div>

          <YoutubeVideo src="https://www.youtube.com/embed/KmAVXhI4wfw" />
          <p className="video-title">Moose Almighty performing at Nectar Lounge in Seattle, WA on July 21, 2022</p>

          

          <div className="Home__section Home__social">
            <SocialLinks />
          </div>

          <div className="Home__section Home__merch">
      
            <div className="Home__merch__img lozad" aria-label="Moose Almighty Merchandise. Shop now at out online store.">
            </div>
          
            <div className="Home__merch__info">
              <h2>Moose Almighty Merchandise</h2>
              <p>
                Now featuring tie dye shirts hand dyed by Moose Almighty's own Chris Young. 
              </p>
              <Link to="/store">
                <button onClick={this.handleClickShopNow} className="btn btn--outline">Shop Now</button>
              </Link>
            </div>
          </div>

          <div className="Home__section">
            <EmailSignup />
          </div>

          
          <div className="Home__section Home__contact">

            <h2>Interested in booking Moose Almighty?</h2> 

              <Link to="/presskit">
                <button className="btn btn--outline Home__contact__btn--1">
                  View press kit
                </button>
              </Link>

              <Link to="/contact">
                <button className="btn btn--outline">
                  Contact Moose Almighty
                </button>
              </Link>

          </div>

          <div className="Home__bottom-logo">
            <img 
              src="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_full_logo_color.png" 
              alt="Moose Almighty logo"
              className="lozad"
            />
          </div>
          


      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/views/Home2/Home2.js